<ah-task-create [taskName]="taskName" [taskId]="taskId" [taskInfo]="taskInfo" [sprintInfo]="sprintInfo" (closeTaskCreate)="closeTask($event)"></ah-task-create>
